"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderOptionally = exports.createOptionalRenderer = exports.debugCompare = exports.createPositiveRendererProps = exports.NO_RENDER = void 0;
const React = require("react");
const keys = require("lodash/keys");
const difference = require("lodash/difference");
const defaults = require("lodash/defaults");
const componentHelpers_1 = require("../helpers/componentHelpers");
// @deprecated
const NO_RENDER = (fallback) => ({
    _toRender: false,
    _fallback: fallback,
});
exports.NO_RENDER = NO_RENDER;
// @deprecated
const createPositiveRendererProps = (props) => ({
    _toRender: true,
    _props: props,
});
exports.createPositiveRendererProps = createPositiveRendererProps;
const debugCompare = (prevProps, nextProps, params) => {
    const { name } = params;
    if (!prevProps || !nextProps) {
        return;
    }
    const prevKeys = keys(prevProps);
    const nextKeys = keys(nextProps);
    if (prevKeys.length !== nextKeys.length) {
        const diffKeys = difference(prevKeys, nextKeys);
        console.log(`DEBUG COMPARE (${name}):`, 'different keys', diffKeys);
        return;
    }
    let diffFound = false;
    prevKeys.forEach((key) => {
        const prevValue = prevProps[key];
        const nextValue = nextProps[key];
        if (prevValue !== nextValue) {
            if (!diffFound) {
                console.group(`DEBUG COMPARE (${name})`);
            }
            diffFound = true;
            console.log(`${String(key)} is different:`, prevValue, nextValue);
        }
    });
    if (diffFound) {
        console.groupEnd();
    }
};
exports.debugCompare = debugCompare;
const createMemoizedSelector = (params) => {
    let cache = null;
    const { getResult, comparator } = params;
    return (value) => {
        const isEqual = cache && comparator(value, cache.value);
        if (!isEqual && params.debug && cache) {
            cache.value && value && exports.debugCompare(cache.value, value, params);
        }
        if (!cache || !isEqual) {
            cache = {
                value,
                result: getResult(value),
            };
        }
        return cache.result;
    };
};
const createOptionalRenderer = (rendererParams) => {
    const params = defaults(rendererParams, {
        debug: false,
        name: 'Unknown',
    });
    return {
        render: createMemoizedSelector(Object.assign(Object.assign({}, params), { getResult: exports.createPositiveRendererProps, comparator: componentHelpers_1.shallowEqual })),
        fallback: createMemoizedSelector(Object.assign(Object.assign({}, params), { getResult: exports.NO_RENDER, comparator: (a, b) => a === b })),
    };
};
exports.createOptionalRenderer = createOptionalRenderer;
const renderOptionally = (WrappedComponent) => {
    const wrappedComponentName = WrappedComponent.displayName
        || WrappedComponent.name
        || 'Component';
    const displayName = `Optional(${wrappedComponentName})`;
    class ResultClass extends React.PureComponent {
        render() {
            if (!this.props._toRender) {
                return this.props._fallback || null;
            }
            return React.createElement(WrappedComponent, this.props._props);
        }
    }
    ResultClass.displayName = displayName;
    return ResultClass;
};
exports.renderOptionally = renderOptionally;
